import React from 'react';
interface LogoMarkProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'light' | 'dark';
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/g9B29f8DwcjSFatLkWJcQ7/Chiltern_Global_Logo-03.svg';
export function LogoMark({
  size = 'md',
  variant = 'light'
}: LogoMarkProps) {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-14'
  };
  return <img src={LOGO_URL} alt="Chiltern Global" className={`${sizeClasses[size]} w-auto ${variant === 'dark' ? 'brightness-0 invert' : ''}`} data-id="element-176" />;
}